/**
 * Starts lazy image downloads before they reach the viewport.
 *
 * Every image in this theme is loading="lazy", and the browser only begins
 * fetching a lazy image once it is almost on screen. With campaign photography
 * that reads as images popping in mid-scroll. Promoting an image to eager once
 * it is within roughly a screen of the viewport starts the same request
 * earlier, without changing which file is requested.
 *
 * Images are observed one by one on purpose. Several sections render a desktop
 * and a mobile <img> and let CSS display only one; a hidden image never
 * intersects, so it is never promoted and never downloaded. Walking a
 * container's descendants instead would download both on every device.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;

  // Vertical: roughly two screens of runway, enough for full-bleed campaign
  // photography to finish before it is scrolled to. Horizontal: one viewport
  // width, so the next slide of a carousel is ready before it is swiped to.
  var ROOT_MARGIN = '1500px 100%';

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      entry.target.loading = 'eager';
    });
  }, { rootMargin: ROOT_MARGIN });

  function watch(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (img.dataset.warmed) return;
      img.dataset.warmed = '1';
      observer.observe(img);
    });
  }

  function start() {
    watch(document);

    // Quick add, pagination and section re-renders inject images later.
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        watch(document);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Wait for load: the above-the-fold images are marked eager/high priority,
  // and warming a screenful of grid images at the same time would compete
  // with them for the connection.
  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start);
  }
})();
